import FormatCurrency from 'components/Common/FormatCurrency'
import FormatDateTime from 'components/utils/Formatters/FormatDateTime'
import FormatDecimal from 'components/utils/Formatters/FormatDecimal'
import Plural from 'components/utils/Formatters/Plural'
import { useAppSelector } from 'hooks/reduxHooks'
import useLoyaltyUserBenefitView from 'loyalty/hooks/useLoyaltyUserBenefitView'
import getLoyaltyDisplayTier from 'loyalty/selectors/getLoyaltyDisplayTier'
import React from 'react'
import LoyaltyTierBenefitMessageBanner from './LoyaltyTierBenefitMessageBanner'

interface Props {
  benefitType: App.LoyaltyBenefitType
  /**
   * @default benefit's availability
   */
  benefitAvailability?: number
}

function LoyaltyTierBenefitAvailabilityMessageBanner({
  benefitType,
  benefitAvailability,
}: Props) {
  const displayTier = useAppSelector(getLoyaltyDisplayTier)
  const statusReviewDate = useAppSelector(state => state.loyalty.account.data?.statusReviewDate)
  const benefitView = useLoyaltyUserBenefitView(benefitType)

  if (!benefitView) return null

  const availability = benefitAvailability ?? benefitView.availability

  if (!availability) return null

  return <LoyaltyTierBenefitMessageBanner
    tier={displayTier}
    benefitType={benefitType}
    density="compact"
    endContent={!!statusReviewDate && <div>
      Expires <b><FormatDateTime value={statusReviewDate} month="short" year="numeric" /></b>
    </div>}
  >
    Available to redeem{' '}
    {benefitType !== 'discounted_insurance' && <b>
      {availability === Infinity && 'unlimited'}
      {availability !== Infinity && <>x<FormatDecimal value={availability} /></>}
      {((benefitType === 'tour_exp_credit' || benefitType === 'travelshoot_credit') && !!benefitView.benefit.value?.amount) && <>
        {' '}<FormatCurrency value={benefitView.benefit.value.amount} format="dynamic" />
        {' '}<Plural count={availability} singular="voucher" plural="vouchers" />
      </>}
    </b>}
    {benefitType === 'discounted_insurance' && <b>{benefitView.benefit.value?.amount}% off</b>}
  </LoyaltyTierBenefitMessageBanner>
}

export default LoyaltyTierBenefitAvailabilityMessageBanner
